import React from 'react';
import Icon, { IconProps } from '../Icon';

const ExclamationCircle: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.50023 0C2.93245 0 0.0291195 2.90333 0.000230636 6.45667C-0.0142138 8.19 0.650231 9.83667 1.87801 11.0644C3.09134 12.3067 4.72356 12.9856 6.4569 13H6.50023C10.068 13 12.9713 10.0967 13.0002 6.54333C13.0291 2.96111 10.1258 0.0288889 6.50023 0ZM6.00912 3.40889C6.00912 3.13444 6.22579 2.91778 6.50023 2.91778C6.77468 2.91778 6.99134 3.13444 6.99134 3.40889V7.45333C6.99134 7.72778 6.77468 7.94444 6.50023 7.94444C6.22579 7.94444 6.00912 7.72778 6.00912 7.45333V3.40889ZM7.16468 9.59111C7.16468 9.95222 6.86134 10.2556 6.50023 10.2556C6.13912 10.2556 5.83579 9.95222 5.83579 9.59111V9.56222C5.83579 9.20111 6.13912 8.89778 6.50023 8.89778C6.86134 8.89778 7.16468 9.20111 7.16468 9.56222V9.59111Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default ExclamationCircle;
